// extracted by mini-css-extract-plugin
module.exports = {"withConfirm":"WithConfirm_withConfirm__EcfXF"};